/* ==========================================================================
   Cart note — grow to fit on mobile
   ==========================================================================

   The order note ships as a fixed 10rem box. On a phone that is a lot of dead
   space directly above the checkout button, for a field most shoppers leave
   empty. The stylesheet collapses it to a single row under 750px; this grows
   it back as the shopper types.

   It grows on INPUT, not on focus. Expanding the moment the field is tapped
   moves the layout while the on-screen keyboard is already animating in, which
   reads as a glitch — and it spends the space before anyone has typed anything.

   Scoped to the same breakpoint as the CSS: above 750px the inline height is
   cleared and Dawn's own sizing applies unchanged.
   ========================================================================== */

(function () {
  var SELECTOR = 'cart-note .text-area';
  var MIN_HEIGHT = 46; // one row; must match the collapsed height in the CSS
  var MAX_HEIGHT = 160; // ~6 lines, then it scrolls internally
  var mobile = window.matchMedia('(max-width: 749px)');

  function fit(textarea) {
    if (!textarea) return;

    if (!mobile.matches) {
      // Hand sizing back to the stylesheet.
      textarea.style.height = '';
      textarea.style.overflowY = '';
      return;
    }

    // Measure from zero, not from 'auto'. A textarea with no rows attribute
    // falls back to its intrinsic two-row box when height is auto, so 'auto'
    // would re-inflate the field to the height we just collapsed.
    textarea.style.height = '0px';
    var borders = textarea.offsetHeight - textarea.clientHeight;
    var wanted = textarea.scrollHeight + borders;

    textarea.style.height = Math.max(MIN_HEIGHT, Math.min(wanted, MAX_HEIGHT)) + 'px';
    textarea.style.overflowY = wanted > MAX_HEIGHT ? 'auto' : 'hidden';
  }

  function fitAll() {
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) fit(nodes[i]);
  }

  // Delegated, so it keeps working after Dawn re-renders the cart drawer.
  document.addEventListener('input', function (event) {
    var el = event.target;
    if (el && el.matches && el.matches(SELECTOR)) fit(el);
  });

  if (mobile.addEventListener) {
    mobile.addEventListener('change', fitAll);
  } else if (mobile.addListener) {
    mobile.addListener(fitAll);
  }

  // A note restored from the cart needs sizing before first paint of the field.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fitAll);
  } else {
    fitAll();
  }

  // Dawn rebuilds the drawer's note on cart changes; re-fit whatever is there.
  var sub = typeof subscribe === 'function' ? subscribe : null;
  var eventName =
    typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate
      ? PUB_SUB_EVENTS.cartUpdate
      : 'cart-update';
  if (sub) sub(eventName, fitAll);
})();